import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Pagination from '@bibliocommons/pagination';

import './ShelfBottomControls.scss';

export default function ShelfBottomControls({ isFetching, pagination }) {
  return (
    <section className="cp-shelf-bottom-controls">
      <Pagination
        showPages
        isFetching={isFetching}
        page={pagination.get('page')}
        limit={pagination.get('limit')}
        count={pagination.get('count')}
        pages={pagination.get('pages')} />
    </section>
  );
}

ShelfBottomControls.propTypes = {
  isFetching: PropTypes.bool,
  pagination: ImmutablePropTypes.map.isRequired
};



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfBottomControls/ShelfBottomControls.jsx